<template>
    <!-- 申请提现(PC) -->
    <ZhaiHeadPC class="zhai-head" />

    <div class="container errong">
        <!-- 顶部栏 -->
        <div class="container-fluid mt-3">
            <div class="row shengse mt-2">
                <div class="dixian px-3 py-2 top-bar-pc">
                    <div class="left lf" @click="goBack">
                        <i class="fa fa-bullhorn"></i> 推广中心
                    </div>
                </div>
            </div>
        </div>

        <!-- 主体 -->
        <div class="withdraw-body-pc">
            <div class="withdraw-shell-pc">

                <div class="page-head">
                    <div class="ph-left">
                        <div class="ph-title">申请提现</div>
                        <div class="ph-sub">选择提现账户并填写金额，提交后进入审核/处理流程</div>
                    </div>

                    <div class="ph-right">
                        <button class="btn-soft" @click="goMyWallet">
                            <i class="fa fa-rmb"></i> 我的钱包
                        </button>
                    </div>
                </div>

                <div class="withdraw-grid">
                    <!-- 左栏：表单 -->
                    <div class="col-left">
                        <!-- 提现账户 -->
                        <div class="card card-account">
                            <div class="card-head-row">
                                <div class="card-title">提现账户</div>
                                <div class="card-action" @click="goSetting">
                                    账户设置 <span class="arrow">›</span>
                                </div>
                            </div>

                            <div class="account-row">
                                <div class="account-left">
                                    <div class="account-icon" :class="accountVisual(currentAccount.type).wrapClass">
                                        <span
                                                v-if="accountVisual(currentAccount.type).mode === 'text'"
                                                class="account-icon-text"
                                        >
                                            {{ accountVisual(currentAccount.type).text }}
                                        </span>
                                        <i v-else class="fa" :class="accountVisual(currentAccount.type).iconClass"></i>
                                    </div>

                                    <div class="account-info">
                                        <div class="account-main">
                                            <span class="account-title">{{ currentAccount.title }}</span>
                                            <span v-if="currentAccount.name" class="account-name">
                                                {{ currentAccount.name }}
                                            </span>
                                        </div>
                                        <div class="account-sub">
                                            {{ displayDesc(currentAccount) }}
                                        </div>
                                    </div>
                                </div>

                                <div class="account-right">
                                    <button class="btn-ghost" @click="openAccountPopup">
                                        切换账户 <span class="arrow">›</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- 提现金额 -->
                        <div class="card card-amount">
                            <div class="card-head-row">
                                <div class="card-title">提现金额</div>
                                <div class="fee-tip">提现收取 5% 手续费</div>
                            </div>

                            <div class="amount-row">
                                <div class="amount-label">金额</div>
                                <div class="amount-input">
                                    <input v-model="amount" type="number" inputmode="decimal" placeholder="请输入提现金额" />
                                    <span class="unit">元</span>
                                </div>
                            </div>

                            <div class="amount-sub">
                                <div class="sub-left">可提现金额 {{ available.toFixed(2) }} 元</div>
                                <div class="sub-right" @click="withdrawAll">全部提现</div>
                            </div>

                            <div class="amount-preview">
                                <div class="preview-item">
                                    <span class="k">预计到账</span>
                                    <span class="v strong">{{ arriveText }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 提交 -->
                        <div class="card card-submit">
                            <button class="submit-btn" :disabled="submitDisabled" @click="submitWithdraw">
                                提交提现
                            </button>
                            <div class="submit-hint">提示：请确认账户信息无误，提交后将进入审核/处理流程。</div>
                        </div>
                    </div>

                    <!-- 右栏：信息 -->
                    <div class="col-right">
                        <div class="card card-side">
                            <div class="side-title">提现信息</div>

                            <div class="side-kv">
                                <div class="kv-row">
                                    <div class="k">可提现余额</div>
                                    <div class="v">{{ available.toFixed(2) }} 元</div>
                                </div>
                                <div class="kv-row">
                                    <div class="k">手续费比例</div>
                                    <div class="v">5%</div>
                                </div>
                                <div class="kv-row">
                                    <div class="k">当前账户</div>
                                    <div class="v">{{ currentAccount.title }}</div>
                                </div>
                            </div>

                            <div class="side-divider"></div>

                            <div class="side-tips">
                                <div class="tips-title">温馨提示</div>
                                <ul class="tips-list">
                                    <li>请确保提现账户信息真实有效。</li>
                                    <li>USDT 地址较长，列表中会省略显示，提交前请核对。</li>
                                    <li>如遇到账延迟，请先检查账户状态，必要时联系客服。</li>
                                </ul>
                            </div>


                        </div>
                    </div>
                </div>

                <div class="gray-gap"></div>
            </div>
        </div>
    </div>

    <div class="gongxi2"></div>

    <!-- ✅ 账户切换弹窗（原样保留） -->
    <transition name="fade">
        <div v-if="showAccountPopup" class="account-mask" @click.self="closeAccountPopup">
            <transition name="zoom">
                <div class="account-modal" @click.stop>
                    <div class="modal-head">
                        <div class="modal-title">请选择提现账户</div>
                        <div class="modal-actions">
                            <button class="link-btn" @click="goSetting">设置</button>
                            <button class="icon-btn" @click="closeAccountPopup" aria-label="close">×</button>
                        </div>
                    </div>

                    <div class="modal-body">
                        <div class="modal-list">
                            <div
                                    class="modal-item"
                                    v-for="item in withdrawAccounts"
                                    :key="item.id"
                                    :class="{ active: item.id === currentAccount.id }"
                                    @click="selectAccount(item)"
                            >
                                <div class="item-left">
                                    <div class="account-icon small" :class="accountVisual(item.type).wrapClass">
                                        <span v-if="accountVisual(item.type).mode === 'text'" class="account-icon-text">
                                            {{ accountVisual(item.type).text }}
                                        </span>
                                        <i v-else class="fa" :class="accountVisual(item.type).iconClass"></i>
                                    </div>

                                    <div class="item-text">
                                        <div class="item-title">
                                            {{ item.title }}
                                            <span v-if="item.name" class="item-name">{{ item.name }}</span>
                                        </div>
                                        <div class="item-desc" :class="{ ellipsis: item.type === 'usdt' }">
                                            {{ displayDesc(item) }}
                                        </div>
                                    </div>
                                </div>

                                <div class="item-right">
                                    <i v-if="item.id === currentAccount.id" class="fa fa-check check"></i>
                                    <span v-else class="chevron">›</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-foot">
                        <button class="btn-cancel" @click="closeAccountPopup">取消</button>
                    </div>
                </div>
            </transition>
        </div>
    </transition>

    <!-- ✅ 新增：未设置提现账户提示（PC版，进入页面即校验弹出） -->
    <transition name="fade">
        <div v-if="showNoAccountModal" class="no-account-mask">
            <div class="no-account-modal-pc">
                <div class="no-account-title">请设置提现账户</div>
                <div class="no-account-desc">
                    设置提现收款账户后才能申请提现<br />
                    即将跳转至设置页面
                </div>
                <div class="no-account-btn" @click="confirmGoSetting">确定</div>
            </div>
        </div>
    </transition>

    <ZhaiFootPC />
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import http from "../utils/http.js";

    export default {
        name: "WalletWithdrawal",
        components: { ZhaiHeadPC, ZhaiFootPC },

        data() {
            return {
                /** ====== API 路径（按你后端实际调整）====== */
                API_PROFILE: "/platform/withdraw/profile",
                API_BALANCE: "/platform/withdraw/balance",
                API_WITHDRAW_APPLY: "/platform/withdraw/apply",

                /** ✅ 规则：余额/可提现金额满 1000 元才允许提现 */
                MIN_WITHDRAW_YUAN: 1000,

                amount: "",
                available: 0, // 元

                showAccountPopup: false,
                showNoAccountModal: false,

                currentUserId: null,

                /** withdraw_profile 原始数据 */
                profile: {
                    realName: "",
                    bankName: "",
                    bankCardNo: "",
                    alipayAccount: "",
                    usdtAddress: "",
                },

                withdrawAccounts: [],

                /** 当前选中账户 */
                currentAccount: {
                    id: "",
                    type: "",
                    title: "",
                    name: "",
                    desc: "",
                    raw: {},
                },
            };
        },

        computed: {
            /** ✅ 是否达到提现门槛（余额≥1000） */
            canWithdrawByBalance() {
                return Number(this.available || 0) >= this.MIN_WITHDRAW_YUAN;
            },

            /** ========== 金额预览 ========== */
            arriveText() {
                const a = Number(this.amount || 0);
                if (!a) return "0.00 元";
                return `${(a * 0.95).toFixed(2)} 元`;
            },

            /** ✅ 提交按钮可用规则：余额≥1000 才能提交 */
            submitDisabled() {
                const a = Number(this.amount || 0);
                if (!this.currentAccount.type) return true;
                if (!this.canWithdrawByBalance) return true;
                if (!a || a <= 0) return true;
                if (a > this.available) return true;
                return false;
            },
        },

        // ✅ 路由守卫：未登录直接跳登录页（与你下方示例一致）
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            // ✅ mounted 兜底：防守卫失效/直开页面
            const token = localStorage.getItem("token");
            if (!token) {
                this.$router.replace("/login");
                return;
            }

            this.currentUserId = this.resolveUserIdSafe();

            await this.loadWithdrawProfile();
            await this.loadWithdrawBalance();
        },

        beforeUnmount() {
            this.unlockBodyScroll();
        },

        methods: {
            /** ========== 统一：登录失效处理 ========== */
            redirectToLogin() {
                // 可按需清 token
                // localStorage.removeItem("token");
                this.unlockBodyScroll();
                this.$router.replace("/login");
            },

            /**
             * 尝试从接口错误/返回体判断是否 token 过期：
             * - axios 401
             * - 后端自定义：json.status == 401 / 403 / -1 / msg 包含 token/登录
             */
            isAuthExpired(err, json) {
                // 1) axios 401
                const statusCode = err?.response?.status;
                if (statusCode === 401 || statusCode === 403) return true;

                // 2) 业务返回码（按你项目实际可再补）
                const s = json?.status;
                if (s === 401 || s === 403 || s === -1) return true;

                // 3) msg 关键字兜底
                const msg = String(json?.msg || err?.message || "");
                if (/token|登录|未登录|过期|失效|unauthorized|forbidden/i.test(msg)) return true;

                return false;
            },

            /** ========== 路由 ========== */
            goBack() {
                if (window.history.length > 1) window.history.back();
                else this.$router.push({ path: "/Promotion" });
            },
            goMyWallet() {
                this.$router.push("/MyWallet");
            },
            goSetting() {
                this.$router.push("/WalletSettings");
            },

            /** ========== body 滚动锁定 ========== */
            lockBodyScroll() {
                const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
                document.body.style.overflow = "hidden";
                document.body.style.paddingRight = scrollbarWidth > 0 ? `${scrollbarWidth}px` : "";
            },
            unlockBodyScroll() {
                document.body.style.overflow = "";
                document.body.style.paddingRight = "";
            },

            /** ========== 稳健拿 userId（有就传；没有就让后端 token 兜底） ========== */
            resolveUserIdSafe() {
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                return null;
            },

            /** ========== 由 profile 生成可提现账户列表 ========== */
            buildAccountsFromProfile(p) {
                const list = [];
                const realName = (p.realName || "").trim();
                const bankName = (p.bankName || "").trim();
                const bankCardNo = (p.bankCardNo || "").trim();
                const alipay = (p.alipayAccount || "").trim();
                const usdt = (p.usdtAddress || "").trim();

                if (realName && bankName && bankCardNo) {
                    list.push({
                        id: "bank",
                        type: "bank",
                        title: "银行账户",
                        name: realName,
                        desc: `${bankName} | ${bankCardNo}`,
                        raw: { realName, bankName, bankCardNo },
                    });
                }
                if (alipay) {
                    list.push({
                        id: "alipay",
                        type: "alipay",
                        title: "支付宝账户",
                        name: realName || "",
                        desc: alipay,
                        raw: { realName, alipayAccount: alipay },
                    });
                }
                if (usdt) {
                    list.push({
                        id: "usdt",
                        type: "usdt",
                        title: "USDT账号",
                        name: realName || "",
                        desc: usdt,
                        raw: { realName, usdtAddress: usdt },
                    });
                }
                return list;
            },

            pickDefaultAccount(list) {
                return (
                    list.find((x) => x.type === "usdt") ||
                    list.find((x) => x.type === "alipay") ||
                    list.find((x) => x.type === "bank") ||
                    list[0]
                );
            },

            applyCurrentAccount(item) {
                if (!item) return;
                this.currentAccount.id = item.id;
                this.currentAccount.type = item.type;
                this.currentAccount.title = item.title;
                this.currentAccount.name = item.name || "";
                this.currentAccount.desc = item.desc || "";
                this.currentAccount.raw = item.raw || {};
            },

            /** ========== 1) 拉提现账户 ========== */
            async loadWithdrawProfile() {
                try {
                    const uid = this.currentUserId || null;
                    const params = uid ? { userId: uid } : null;

                    const res = await http.get(this.API_PROFILE, params);
                    const json = res?.data;

                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || json.status !== 1) {
                        console.error("[withdraw_profile] api failed:", json);
                        return;
                    }

                    const d = json.data || {};
                    this.profile.realName = d.realName || d.real_name || "";
                    this.profile.bankName = d.bankName || d.bank_name || "";
                    this.profile.bankCardNo =
                        d.bankCardNo || d.bank_card_no || d.bankAccount || d.bank_account || "";
                    this.profile.alipayAccount = d.alipayAccount || d.alipay_account || "";
                    this.profile.usdtAddress = d.usdtAddress || d.usdt_address || "";

                    const list = this.buildAccountsFromProfile(this.profile);
                    this.withdrawAccounts = list;

                    if (list.length === 0) {
                        this.showNoAccountModal = true;
                        this.lockBodyScroll();
                        return;
                    }

                    const def = this.pickDefaultAccount(list);
                    this.applyCurrentAccount(def);
                } catch (e) {
                    // axios 401/403
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }
                    console.error("[withdraw_profile] exception:", e);
                }
            },

            /** ========== 2) 拉可提现余额（✅ 修正字段：balanceCent） ========== */
            async loadWithdrawBalance() {
                try {
                    const uid = this.currentUserId || null;
                    const params = uid ? { userId: uid } : null;

                    const res = await http.get(this.API_BALANCE, params);
                    const json = res?.data;

                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || json.status !== 1) {
                        console.error("[withdraw_balance] api failed:", json);
                        return;
                    }

                    const d = json.data || {};
                    const cent = Number(d.availableCent ?? d.balanceCent ?? d.available_cent ?? d.balance_cent ?? 0);
                    this.available = Math.max(0, cent / 100);
                } catch (e) {
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }
                    console.error("[withdraw_balance] exception:", e);
                }
            },

            /** ========== 弹窗/切换 ========== */
            openAccountPopup() {
                this.showAccountPopup = true;
                this.lockBodyScroll();
            },
            closeAccountPopup() {
                this.showAccountPopup = false;
                this.unlockBodyScroll();
            },
            selectAccount(item) {
                this.applyCurrentAccount(item);
                this.closeAccountPopup();
            },

            /** 无账户提示弹窗 */
            confirmGoSetting() {
                this.showNoAccountModal = false;
                this.unlockBodyScroll();
                this.$router.replace("/WalletSettings");
            },

            /** ========== 展示脱敏 ========== */
            displayDesc(item) {
                if (!item || !item.desc) return "";
                if (item.type === "bank") {
                    const parts = String(item.desc).split("|").map((s) => s.trim());
                    if (parts.length >= 2) return `${parts[0]} | ${this.maskBankCard(parts[1])}`;
                    return this.maskBankCard(item.desc);
                }
                if (item.type === "alipay") return this.maskPhone(item.desc);
                return String(item.desc);
            },

            maskPhone(str) {
                const s = String(str).replace(/\s/g, "");
                if (/^\d{11}$/.test(s)) return s.slice(0, 3) + "****" + s.slice(7);
                if (s.length <= 4) return s;
                return s.slice(0, 2) + "****" + s.slice(-2);
            },
            maskBankCard(str) {
                const digits = String(str).replace(/\s/g, "");
                if (digits.length <= 8) return digits;
                const head = digits.slice(0, 4);
                const tail = digits.slice(-4);
                return `${head} **** **** ${tail}`;
            },

            accountVisual(type) {
                const map = {
                    usdt: { mode: "icon", iconClass: "fa-diamond", wrapClass: "account-icon-usdt" },
                    alipay: { mode: "text", text: "支", wrapClass: "account-icon-alipay" },
                    bank: { mode: "icon", iconClass: "fa-university", wrapClass: "account-icon-bank" },
                };
                return map[type] || map.bank;
            },

            /** ✅ 全部提现：余额不足1000时不允许 */
            withdrawAll() {
                if (!this.canWithdrawByBalance) {
                    alert(`余额满${this.MIN_WITHDRAW_YUAN}元才可提现`);
                    return;
                }
                if (this.available <= 0) return;
                this.amount = this.available.toFixed(2);
            },

            /** ✅ 提交提现：余额不足1000直接拦截 + 登录过期跳登录 */
            async submitWithdraw() {
                // 0) token 兜底
                const token = localStorage.getItem("token");
                if (!token) {
                    this.redirectToLogin();
                    return;
                }

                // 1️⃣ 校验是否选择了账户
                if (!this.currentAccount.type) {
                    this.showNoAccountModal = true;
                    this.lockBodyScroll();
                    return;
                }

                // 2️⃣ 提交前重新拉一次余额（防并发 / 防抓包）
                await this.loadWithdrawBalance();

                // loadWithdrawBalance 内可能触发 redirect
                if (!localStorage.getItem("token")) return;

                // ✅ 新增：余额门槛校验
                if (!this.canWithdrawByBalance) {
                    alert(`余额满${this.MIN_WITHDRAW_YUAN}元才可提现`);
                    return;
                }

                // 3️⃣ 校验金额
                const a = Number(this.amount || 0);
                if (!a || a <= 0) {
                    alert("请输入正确的提现金额");
                    return;
                }
                if (a > this.available) {
                    alert("提现金额超过可提现余额");
                    return;
                }

                // 4️⃣ 提现方式映射：1 = 银行卡，2 = 支付宝，3 = USDT
                const method = this.currentAccount.type === "bank" ? 1 : this.currentAccount.type === "alipay" ? 2 : 3;

                // 5️⃣ 元 -> 分（整数）
                const requestCent = Math.round(a * 100);

                // 6️⃣ 组装 body
                const body = {
                    method,
                    requestCent,
                    realName: this.currentAccount.raw?.realName || this.profile.realName || "",
                    bankName: this.currentAccount.raw?.bankName || "",
                    bankCardNo: this.currentAccount.raw?.bankCardNo || "",
                    alipayAccount: this.currentAccount.raw?.alipayAccount || "",
                    usdtAddress: this.currentAccount.raw?.usdtAddress || "",
                };

                try {
                    // 7️⃣ userId 拼在 URL（适配你现有 http.js）
                    const uid = this.currentUserId;
                    const url = uid ? `${this.API_WITHDRAW_APPLY}?userId=${uid}` : this.API_WITHDRAW_APPLY;

                    // 8️⃣ 发起请求
                    const res = await http.post(url, body);
                    const json = res?.data;

                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || json.status !== 1) {
                        alert(json?.msg || "提交失败");
                        return;
                    }

                    alert("提交成功，已进入审核流程");
                    this.amount = "";

                    // 提交成功后刷新余额
                    await this.loadWithdrawBalance();
                } catch (e) {
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }
                    console.error("[withdraw_apply] exception:", e);
                    alert("提交失败，请稍后再试");
                }
            },
        },
    };
</script>


<style scoped>
    /* 基础 */
    body {
        font-family: Arial, sans-serif;
    }
    /* ✅ 新增：页头（与其它钱包页面保持一致） */
    .page-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 14px;
        background: #fff;
        border: 1px solid #eee;
        border-radius: 2px;
        margin-bottom: 12px;
    }
    .ph-left { min-width: 0; }
    .ph-title { font-size: 16px; font-weight: 900; color: #111; }
    .ph-sub { margin-top: 6px; font-size: 13px; color: #888; }
    .ph-right { display: flex; gap: 10px; flex-wrap: wrap; }

    .btn-soft {
        height: 36px;
        padding: 0 12px;
        border-radius: 2px;
        border: 1px solid #eee;
        background: #fafafa;
        font-size: 13px;
        cursor: pointer;
        color: #333;
        display: inline-flex;
        align-items: center;
    }
    .btn-soft .fa { margin-right: 8px; color: #00c26f; }
    .btn-soft:active { opacity: 0.8; }

    .lf {
        font-weight: 900;
    }
    .fa {
        margin-right: 6px;
    }
    .gongxi2 {
        height: 20px;
    }
    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }
        .errong {
            margin-top: 80px;
        }
    }

    /* 顶部栏 */
    .top-bar-pc {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
    }
    .top-bar-pc .left {
        cursor: pointer;
        color: #333;
        font-size: 15px;
        display: inline-flex;
        align-items: center;
    }
    .top-bar-pc .left:active {
        opacity: 0.75;
    }
    .top-bar-pc .center {
        justify-self: center;
        font-size: 16px;
        font-weight: 800;
        color: #00c26f;
    }
    .top-bar-pc .right {
        justify-self: end;
        cursor: pointer;
        color: #00c26f;
        font-size: 14px;
        display: inline-flex;
        align-items: center;
    }
    .arrow {
        margin-left: 6px;
        font-size: 18px;
        color: #aaa;
    }

    /* 灰底区 */
    .withdraw-body-pc {
        background: #efefef;
        border-radius: 16px;
        margin-top: 10px;
    }
    .withdraw-shell-pc {
        max-width: 1200px;
        margin: 0 auto;
        /*padding: 16px;*/
    }

    /* 两栏 */
    .withdraw-grid {
        display: grid;
        grid-template-columns: 1.6fr 1fr;
        gap: 16px;
    }
    @media (max-width: 992px) {
        .withdraw-grid {
            grid-template-columns: 1fr;
        }
    }

    /* 卡片 */
    .card {
        background: #fff;
        border-radius: 2px;
        box-shadow: 0 10px 26px rgba(0, 0, 0, 0.06);
        padding: 16px;
    }
    .card + .card {
        margin-top: 12px;
    }

    .card-head-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 12px;
        border-bottom: 1px solid #f2f2f2;
        margin-bottom: 12px;
    }
    .card-title {
        font-size: 15px;
        font-weight: 800;
        color: #111;
    }
    .card-action {
        font-size: 13px;
        color: #2f6fed;
        cursor: pointer;
    }
    .card-action:active {
        opacity: 0.75;
    }
    .fee-tip {
        font-size: 13px;
        color: #ff4d4f;
    }

    /* 账户行 */
    .account-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
    }
    .account-left {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
    }
    .account-info {
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .account-main {
        display: flex;
        align-items: baseline;
        gap: 8px;
        min-width: 0;
    }
    .account-title {
        font-size: 15px;
        font-weight: 800;
        color: #111;
    }
    .account-name {
        font-size: 13px;
        color: #999;
    }
    .account-sub {
        font-size: 13px;
        color: #999;
        word-break: break-all;
    }

    /* 图标 */
    .account-icon {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        background: #fff;
        border: 2px solid #ff6b6b;
    }
    .account-icon .fa {
        margin-right: 0;
        font-size: 18px;
        color: #ff6b6b;
    }
    .account-icon-text {
        font-size: 18px;
        font-weight: 900;
        line-height: 1;
    }
    .account-icon.small {
        width: 40px;
        height: 40px;
    }
    .account-icon.small .fa {
        font-size: 16px;
    }
    .account-icon.small .account-icon-text {
        font-size: 16px;
    }
    .account-icon-usdt {
        border-color: #16a085;
    }
    .account-icon-usdt .fa,
    .account-icon-usdt .account-icon-text {
        color: #16a085;
    }
    .account-icon-alipay {
        border-color: #2f6fed;
    }
    .account-icon-alipay .fa,
    .account-icon-alipay .account-icon-text {
        color: #2f6fed;
    }
    .account-icon-bank {
        border-color: #ff6b6b;
    }
    .account-icon-bank .fa,
    .account-icon-bank .account-icon-text {
        color: #ff6b6b;
    }

    .btn-ghost {
        border: 1px solid #e9e9e9;
        background: #fff;
        border-radius: 10px;
        height: 36px;
        padding: 0 12px;
        font-size: 13px;
        color: #333;
        cursor: pointer;
    }
    .btn-ghost:active {
        opacity: 0.75;
    }

    /* 金额 */
    .amount-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 6px 0 10px;
    }
    .amount-label {
        font-size: 14px;
        font-weight: 800;
        color: #111;
        min-width: 56px;
    }
    .amount-input {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
    }
    .amount-input input {
        width: 100%;
        max-width: 360px;
        border: 1px solid #eee;
        border-radius: 10px;
        height: 40px;
        padding: 0 12px;
        outline: none;
        font-size: 14px;
        text-align: right;
    }
    .amount-input input:focus {
        border-color: rgba(0, 194, 111, 0.5);
        box-shadow: 0 0 0 3px rgba(0, 194, 111, 0.08);
    }
    .unit {
        color: #999;
        font-size: 13px;
    }
    .amount-sub {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #f7f7f7;
        padding-top: 10px;
        margin-top: 6px;
    }
    .sub-left {
        font-size: 13px;
        color: #999;
    }
    .sub-right {
        font-size: 13px;
        color: #2f6fed;
        cursor: pointer;
    }
    .sub-right:active {
        opacity: 0.75;
    }

    /* 预览 */
    .amount-preview {
        margin-top: 12px;
        padding: 12px;
        border-radius: 10px;
        background: #fafafa;
        border: 1px solid #f0f0f0;
    }
    .preview-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 0;
    }
    .preview-item .k {
        font-size: 13px;
        color: #777;
    }
    .preview-item .v {
        font-size: 13px;
        color: #111;
    }
    .preview-item .v.strong {
        font-weight: 900;
        color: #00c26f;
    }

    /* 提交 */
    .submit-btn {
        width: 100%;
        height: 44px;
        border: none;
        border-radius: 10px;
        color: #fff;
        font-size: 15px;
        font-weight: 900;
        background: linear-gradient(90deg, #ff6b6b, #ff7e67);
        cursor: pointer;
    }
    .submit-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    .submit-hint {
        margin-top: 10px;
        font-size: 12px;
        color: #999;
        line-height: 1.6;
    }

    /* 右侧 */
    .card-side .side-title {
        font-size: 15px;
        font-weight: 900;
        color: #111;
        margin-bottom: 10px;
    }
    .side-kv {
        border: 1px solid #f2f2f2;
        border-radius: 10px;
        padding: 10px 12px;
        background: #fff;
    }
    .kv-row {
        display: flex;
        justify-content: space-between;
        padding: 8px 0;
        border-bottom: 1px dashed #f0f0f0;
    }
    .kv-row:last-child {
        border-bottom: 0;
    }
    .kv-row .k {
        font-size: 13px;
        color: #777;
    }
    .kv-row .v {
        font-size: 13px;
        color: #111;
        font-weight: 700;
    }
    .side-divider {
        height: 1px;
        background: #f2f2f2;
        margin: 14px 0;
    }
    .tips-title {
        font-size: 13px;
        font-weight: 900;
        color: #111;
        margin-bottom: 8px;
    }
    .tips-list {
        margin: 0;
        padding-left: 18px;
        color: #777;
        font-size: 13px;
        line-height: 1.8;
    }
    .side-actions {
        margin-top: 14px;
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }
    .btn-outline {
        height: 36px;
        padding: 0 12px;
        border-radius: 10px;
        border: 1px solid #e9e9e9;
        background: #fff;
        font-size: 13px;
        cursor: pointer;
    }
    .btn-outline:active {
        opacity: 0.75;
    }

    .gray-gap {
        height: 20px;
    }

    /* ✅ 账户切换遮罩 */
    .account-mask {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.45);
        z-index: 20000;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
    }

    /* ✅ 账户切换弹窗主体 */
    .account-modal {
        width: 760px;
        max-width: 100%;
        background: #fff;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 26px 60px rgba(0, 0, 0, 0.18);
    }

    .modal-head {
        padding: 14px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f3f3f3;
    }
    .modal-title {
        font-size: 15px;
        font-weight: 900;
        color: #111;
    }
    .modal-actions {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .link-btn {
        border: 0;
        background: transparent;
        color: #2f6fed;
        font-size: 13px;
        cursor: pointer;
    }
    .icon-btn {
        width: 32px;
        height: 32px;
        border-radius: 10px;
        border: 1px solid #eee;
        background: #fff;
        cursor: pointer;
        font-size: 18px;
        line-height: 30px;
        text-align: center;
    }
    .modal-body {
        padding: 10px 0;
    }
    .modal-list {
        max-height: 420px;
        overflow-y: auto;
    }

    .modal-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #f6f6f6;
        cursor: pointer;
        background: #fff;
    }
    .modal-item:hover {
        background: #fafafa;
    }
    .modal-item.active {
        background: rgba(0, 194, 111, 0.06);
    }

    .item-left {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
    }
    .item-text {
        min-width: 0;
        display: flex;
        flex-direction: column;
    }
    .item-title {
        font-size: 14px;
        color: #111;
    }
    .item-name {
        margin-left: 8px;
        font-size: 12px;
        color: #999;
    }
    .item-desc {
        font-size: 12px;
        color: #999;
        margin-top: 3px;
        max-width: 560px;
        word-break: break-all;
    }
    .item-desc.ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: normal;
    }

    .item-right {
        min-width: 28px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .check {
        color: #00c26f;
        font-size: 18px;
        margin-right: 0;
    }
    .chevron {
        color: #c7c7c7;
        font-size: 20px;
        line-height: 1;
    }

    .modal-foot {
        padding: 12px 16px;
        border-top: 1px solid #f3f3f3;
        display: flex;
        justify-content: flex-end;
    }
    .btn-cancel {
        height: 36px;
        padding: 0 14px;
        border-radius: 10px;
        border: 1px solid #e9e9e9;
        background: #fff;
        font-size: 13px;
        cursor: pointer;
    }

    /* 动画 */
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.18s ease;
    }
    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
    .zoom-enter-active,
    .zoom-leave-active {
        transition: transform 0.18s ease, opacity 0.18s ease;
    }
    .zoom-enter-from,
    .zoom-leave-to {
        transform: scale(0.98);
        opacity: 0;
    }

    /* ========== ✅ 新增：PC 未设置提现账户提示弹窗 ========= */
    .no-account-mask {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.45);
        z-index: 30000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .no-account-modal-pc {
        width: 360px;
        max-width: 92vw;
        background: #fff;
        border-radius: 14px;
        padding: 26px 22px 16px;
        text-align: center;
        box-shadow: 0 26px 60px rgba(0, 0, 0, 0.18);
    }

    .no-account-title {
        font-size: 18px;
        font-weight: 900;
        color: #111;
        margin-bottom: 12px;
    }

    .no-account-desc {
        font-size: 14px;
        color: #999;
        line-height: 1.6;
        margin-bottom: 16px;
    }

    .no-account-btn {
        font-size: 16px;
        color: #ff4d4f;
        font-weight: 700;
        padding-top: 12px;
        border-top: 1px solid #f0f0f0;
        cursor: pointer;
    }

    .no-account-btn:active {
        opacity: 0.7;
    }
</style>
